var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.s.container,on:{"click":function($event){return _vm.$store.dispatch('toggleTheme')}}},[(_vm.$store.getters.isThemeDark)?_c('Icon',{attrs:{"icon":"light_on"}}):_c('Icon',{class:_vm.s.violet,attrs:{"icon":"light_off"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }